import { toPrecision } from '@curbnturf/helpers';
import { ActivityLocation } from '@curbnturf/objects';
import { IActivityLocation, IPoiPoint } from '../interfaces';
import { Address } from './address';
import { MapPoint } from './map-point';

export class PoiPoint extends MapPoint implements IPoiPoint {
  syncId?: string;
  poi: ActivityLocation;

  public static fromActivity(activity: IActivityLocation | ActivityLocation): PoiPoint {
    const mapPoint = new this();

    if (activity.coordinates) {
      mapPoint.coordinates = {
        lat: toPrecision(activity.coordinates.lat, 2),
        lon: toPrecision(activity.coordinates.lon, 2),
      };
    }

    if (activity.id && activity.name) {
      mapPoint.id = activity.id;
      mapPoint.name = activity.name;
    }

    if (activity.description) {
      mapPoint.description = activity.description;
    }

    if (activity.photos) {
      mapPoint.photos = activity.photos;
    } else {
      mapPoint.photos = [];
    }

    if (activity.address && activity.address.city && activity.address.state) {
      mapPoint.location = `${activity.address.city}, ${activity.address.state}`;
    } else if (activity.address && activity.address.city) {
      mapPoint.location = `${activity.address.city}`;
    } else if (activity.address && activity.address.state) {
      mapPoint.location = `${activity.address.state}`;
    } else {
      mapPoint.location = '';
    }

    mapPoint.poi = new ActivityLocation(activity);

    mapPoint.rating = 0;
    mapPoint.ratingCount = 0;

    if (activity.ratings && activity.ratings.length > 0) {
      const ratingInformation = activity.ratings.reduce(
        (acc, rating) => {
          acc.ratingTotal += rating.score?.score || 0;
          acc.ratingCount += 1;
          return acc;
        },
        { ratingTotal: 0, ratingCount: 0 },
      );
      mapPoint.rating = toPrecision(ratingInformation.ratingTotal / ratingInformation.ratingCount, 1);
      mapPoint.ratingCount = ratingInformation.ratingCount;
    }

    return mapPoint;
  }
  constructor(data?: IPoiPoint) {
    super(data);

    if (data) {
      this.setData(data);
    }
  }

  override setData(data: IPoiPoint): void {
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (this as any)[key] = (data as any)[key];
      }
    }

    if (this.address) {
      this.address = new Address(this.address);
    }

    if (this.poi) {
      this.poi = new ActivityLocation(this.poi);
    }
  }

  getName(): string {
    return this.name || 'Unidentified Activity';
  }
}
